import { useLang, MANIFESTO } from "../i18n";
import { Reveal, Eyebrow } from "../components/Reveal";
import Marquee from "../components/Marquee";
import Stats from "../components/Stats";
import { imgProps } from "../lib/api";

const IMG_A = "arte-infissi/images/00dca2e5-6af4-4061-96de-557fd986b289.webp";
const IMG_B = "arte-infissi/images/03ae83da-a2ac-4ddd-abdf-52e5d94b810e.webp";

export default function About() {
  const { t, lang } = useLang();
  const services = [
    { title: t.about_s1_title, text: t.about_s1_text },
    { title: t.about_s2_title, text: t.about_s2_text },
    { title: t.about_s3_title, text: t.about_s3_text },
  ];

  return (
    <div data-testid="about-page" className="pt-32 sm:pt-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>{t.about_eyebrow}</Eyebrow>
          <h1 className="mt-4 max-w-4xl font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05] text-[#F3EFE6]">{t.about_title}</h1>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <Reveal className="lg:col-span-7">
            <div className="aspect-[4/3] overflow-hidden border border-[#262420]">
              <img {...imgProps(IMG_A, "(max-width: 1024px) 100vw, 58vw")} alt="Arte & Infissi" loading="lazy" className="h-full w-full object-cover transition-transform [transition-duration:1500ms] hover:scale-105" />
            </div>
          </Reveal>
          <div className="lg:col-span-5 flex flex-col justify-center gap-8">
            <Reveal delay={0.1}><p className="text-base sm:text-lg font-light text-[#A39E93] leading-relaxed">{t.about_p1}</p></Reveal>
            <Reveal delay={0.2}><p className="text-base sm:text-lg font-light text-[#A39E93] leading-relaxed">{t.about_p2}</p></Reveal>
          </div>
        </div>
      </div>

      <div className="mt-24"><Stats /></div>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-7">
            <Reveal><Eyebrow>{t.about_services_eyebrow}</Eyebrow></Reveal>
            <div className="mt-10">
              {services.map((s, i) => (
                <Reveal key={s.title} delay={i * 0.06}>
                  <div data-testid={`service-${i}`} className="group border-t border-[#1C1A17] py-8 transition-colors duration-500 hover:bg-[#0F0F0E]">
                    <div className="flex gap-6">
                      <span className="font-mono text-xl text-[#C8A86B]/60 group-hover:text-[#C8A86B] transition-colors">0{i + 1}</span>
                      <div>
                        <h3 className="font-serif text-xl sm:text-2xl text-[#F3EFE6]">{s.title}</h3>
                        <p className="mt-3 text-sm sm:text-base font-light leading-relaxed text-[#A39E93]">{s.text}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
              <div className="border-t border-[#1C1A17]" />
            </div>
          </div>
          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden border border-[#262420]">
              <img {...imgProps(IMG_B, "(max-width: 1024px) 100vw, 42vw")} alt="Tende da sole" loading="lazy" className="h-full w-full object-cover transition-transform [transition-duration:1500ms] hover:scale-105" />
            </div>
          </Reveal>
        </div>
      </section>

      <Marquee />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <Reveal>
          <Eyebrow>{t.manifesto_eyebrow}</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F3EFE6]">{t.manifesto_title}</h2>
        </Reveal>
        <div className="mt-16">
          {MANIFESTO.map((ch, i) => (
            <Reveal key={ch.number} delay={i * 0.05}>
              <div className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 border-t border-[#1C1A17] py-12 transition-colors duration-500 hover:bg-[#0F0F0E]">
                <span className="md:col-span-2 font-mono text-4xl sm:text-5xl text-[#C8A86B]/60 transition-colors duration-500 group-hover:text-[#C8A86B]">{ch.number}</span>
                <h3 className="md:col-span-4 font-serif text-xl sm:text-2xl font-normal text-[#F3EFE6] leading-snug">{lang === "it" ? ch.title_it : ch.title_en}</h3>
                <p className="md:col-span-6 text-sm sm:text-base font-light text-[#A39E93] leading-relaxed">{lang === "it" ? ch.content_it : ch.content_en}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
